import { createRoot } from 'react-dom/client'
import App from './App'
import Modal from 'react-modal'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

Modal.setAppElement('#root')

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <GoogleReCaptchaProvider
    reCaptchaKey={'6LeuADMsAAAAAMTeXGQjql2LHv_ibGhVroi5a_DG'}
    scriptProps={{ async: true, defer: true }}
  >
    <App />
  </GoogleReCaptchaProvider>
)
